import { Component } from '@angular/core';

@Component({
  selector: 'jet-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {}
